import { PortableText, isPortableTextEmpty } from '@/app/components/questionnaireV2/components/portable-text';
import TooltipIcon from '@/app/components/questionnaireV2/icons/tooltip-icon';
import { TooltipModal, useModal } from '../../../tooltip/tooltip-modal';
import WhyWeAsk from '../../../why-we-ask';
import { QuestionnaireCategoryItemsItemOneOf as Question } from '@/api/generated-catch-backend/model';
import { RefObject } from 'react';

export interface QuestionHeaderProps {
  question: Question;
  hideWhyWeAsk?: boolean;
  onWhyWeAskExpand?: () => void;
  questionTitleRef?: RefObject<HTMLDivElement>;
}

export function QuestionHeader({
  question,
  hideWhyWeAsk,
  onWhyWeAskExpand,
  questionTitleRef,
}: QuestionHeaderProps) {
  const { isOpen, openModal, closeModal } = useModal();

  const titleContent = question.title;
  const subtitleContent = question.subtitle;
  const tooltipContent = question.tooltip;
  const whyWeAskContent = question.whyWeAsk;

  return (
    <div className="questionnaire-question-header" ref={questionTitleRef}>
      {!isPortableTextEmpty(titleContent) && (
        <h2 className="questionnaire-question-title">
          <PortableText
            content={titleContent}
            inline
            trailingContent={
              !isPortableTextEmpty(tooltipContent) && (
                <button className="questionnaire-tooltip-icon" type="button" onClick={openModal} aria-label="Show tooltip">
                  <TooltipIcon />
                </button>
              )
            }
          />
        </h2>
      )}

      {!isPortableTextEmpty(subtitleContent) && (
        <div className="questionnaire-question-subtitle">
          <PortableText content={subtitleContent} />
        </div>
      )}

      {!hideWhyWeAsk && !isPortableTextEmpty(whyWeAskContent) ? (
        <WhyWeAsk explanation={whyWeAskContent} onExpand={onWhyWeAskExpand} />
      ) : (
        // Include container for consistent padding without why we ask
        <div className="why-we-ask-container" />
      )}

      <TooltipModal isOpen={isOpen} onClose={closeModal}>
        <PortableText content={tooltipContent} />
      </TooltipModal>
    </div>
  );
}
